import type { Locale } from '@pickpro/i18n';

export function swapLocaleSegment(pathname: string, locale: Locale): string {
  const segments = pathname.split('/');
  segments[1] = locale;
  return segments.join('/');
}
